import { injector } from '@asd-stan/injector/injector';

import { DraftRepo } from '../api/draft.repo';
import { DraftService } from '../domain/draft.service';

import { DRAFT_REPO, DRAFT_SERVICE } from './constants';

injector.set(DRAFT_REPO, new DraftRepo());
injector.set(DRAFT_SERVICE, new DraftService());
